module.exports = __webpack_public_path__ + "static/media/testImage.e91a2094.jpeg";